import React, { useState } from "react";
import { Button, Tooltip } from "@material-ui/core";
import ShowcaseService from "../../services/ShowcaseService";

// icons
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { FiExternalLink } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import CustomYesNoModal from "../micro_components/CustomYesNoModal";
import { CgDice5 } from "react-icons/cg";

function ShowcaseCard({
  id,
  name = "New showcase",
  pin = "0000",
  bannerURL = "(no URL)",
  openModal,
  setSelected,
  refreshShowcases,
}) {
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState(name);
  const [newPin, setNewPin] = useState(pin);
  const [newBannerURL, setNewBannerURL] = useState(bannerURL);
  const [loading, setLoading] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleCancelDetails = () => {
    setEditing(false);
    setNewName(null);
    setNewPin(null);
    setNewBannerURL(null);
  };

  const handleSaveDetails = () => {
    setLoading(true);
    ShowcaseService.updateDetails(id, {
      title: newName,
      pin: newPin,
      bannerUrl: newBannerURL,
    })
      .then((res) => {
        console.log("Success changing showcase info");
        setEditing(false);
        setLoading(false);
      })
      .catch((e) => {
        console.log("Error changing showcase info:", e);
        window.alert("Error saving data for showcase");
        setLoading(false);
      });
  };

  const randomizePin = () => {
    let randPin = Math.floor(Math.random() * 9999);
    let newPin = `${randPin < 10 ? "000" : randPin < 100 ? "00" : randPin < 1000 ? "0" : ""}${randPin}`;
    setNewPin(newPin);
  };

  // const writeLinkToClipboard = () => {
  //   navigator.permissions.query({ name: "clipboard-write" }).then((res) => {
  //     if (res.state === "granted" || res.state === "prompt")
  //       navigator.clipboard.writeText(`https://dpi-showcase.netlify.app/showcase/${id}/${pin}`);
  //   });
  // };

  const deleteSelf = () => {
    setDeleteModalOpen(false);
    setLoading(true);
    ShowcaseService.remove(id)
      .then(() => {
        setLoading(false);
        refreshShowcases();
      })
      .catch((e) => {
        window.alert("Error deleting  showcase");
      });
  };

  const openDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  return (
    <div className="showcase-card">
      <div className="name-and-pin">
        <div className="showcase-details-editor">
          {editing ? (
            <>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">Name</span>
                <input
                  type="text"
                  className="showcase-name"
                  value={newName || name}
                  onChange={(e) => {
                    setNewName(e.target.value);
                  }}
                />
              </div>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">PIN</span>
                <input
                  type="text"
                  pattern="^[0-9]*$"
                  maxLength="4"
                  className="showcase-pin"
                  value={newPin || pin}
                  onChange={(e) => {
                    if (/^[0-9]*$/.test(e.target.value)) setNewPin(e.target.value);
                  }}
                />
              </div>
              <Tooltip title="Randomize PIN">
                <div className="randomize-pin" onClick={randomizePin}>
                  <CgDice5 />
                </div>
              </Tooltip>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">URL to banner image</span>
                <input
                  type="text"
                  className="showcase-bannerURL"
                  placeholder="http://..."
                  value={newBannerURL}
                  onChange={(e) => {
                    setNewBannerURL(e.target.value);
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">Name</span>
                <span className="showcase-name">{newName || name}</span>
              </div>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">PIN</span>
                <span className="showcase-pin">{newPin || pin}</span>
              </div>
              <div className="showcase-detail-container">
                <span className="showcase-detail-label">URL to banner image</span>
                <span className="showcase-pin">{newBannerURL || bannerURL}</span>
              </div>
            </>
          )}
        </div>
        {editing ? (
          <div className="showcase-card-edit-buttons">
            <Button color="secondary" disabled={loading} onClick={handleCancelDetails}>
              Cancel
            </Button>
            <Button color="primary" disabled={loading} onClick={handleSaveDetails}>
              Save
            </Button>
            {loading && <AiOutlineLoading3Quarters />}
          </div>
        ) : (
          <Button color="primary" onClick={() => setEditing(true)}>
            Edit details
          </Button>
        )}
      </div>
      <div className="showcase-buttons">
        <a
          className="showcase-external-link"
          href={`https://dpi-showcase.netlify.app/showcase/${id}/${pin}`}
          target="_blank"
          rel="noreferrer"
        >
          <FiExternalLink />
        </a>
        <Button
          color="primary"
          endIcon={<EditIcon />}
          style={{ marginRight: "0.5rem" }}
          onClick={() => {
            openModal();
            setSelected();
          }}
        >
          Manage books
        </Button>
        <Button color="secondary" onClick={openDeleteModal} endIcon={<DeleteIcon />}>
          Delete
        </Button>
        {deleteModalOpen && (
          <CustomYesNoModal
            title={"Are you sure you want to delete " + name + "?"}
            isOpen={deleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            onSubmit={deleteSelf}
            initial={""}
          />
        )}
      </div>
    </div>
  );
}

export default ShowcaseCard;
